/* Load optional theme components once, only when their markup is present. */
(() => {
  if (window.AyeiorModuleLoader) return;
  const manifest = document.getElementById('ayeior-component-manifest');
  if (!manifest) return;
  let config;
  try { config = JSON.parse(manifest.textContent); } catch (_) { return; }
  const pending = new Map(config.map(entry => [entry.url, entry]));
  const loading = new Set();
  const retryAfter = new Map();
  let selector = '';
  let observing = false;
  let flushTimer = 0;
  const queuedRoots = new Set();
  const rebuild = () => { selector = [...pending.values()].filter(entry => !loading.has(entry.url)).map(entry => entry.selector).join(','); };
  const load = entry => {
    if (loading.has(entry.url) || (retryAfter.get(entry.url) || 0) > Date.now()) return;
    loading.add(entry.url);
    rebuild();
    import(entry.url).then(() => {
      pending.delete(entry.url);
      retryAfter.delete(entry.url);
      rebuild();
      if (!pending.size) {
        observer.disconnect();
        observing = false;
        queuedRoots.clear();
        clearTimeout(flushTimer);
        flushTimer = 0;
      }
    }).catch(() => { retryAfter.set(entry.url, Date.now() + 5000); })
      .finally(() => { loading.delete(entry.url); rebuild(); });
  };
  function scan(scope = document) {
    if (!selector || !scope.querySelectorAll) return;
    const nodes = [];
    if (scope instanceof Element && scope.matches(selector)) nodes.push(scope);
    nodes.push(...scope.querySelectorAll(selector));
    // One selector search per subtree, not one search per missing feature.
    for (const node of nodes) for (const entry of pending.values()) {
      if (!loading.has(entry.url) && node.matches(entry.selector)) load(entry);
    }
  }
  function flush() {
    flushTimer = 0;
    const roots = new Set(queuedRoots);
    queuedRoots.clear();
    for (const root of roots) {
      if (!root.isConnected) continue;
      let parent = root.parentElement;
      while (parent && !roots.has(parent)) parent = parent.parentElement;
      if (!parent) scan(root);
    }
  }
  const observer = new MutationObserver(records => {
    if (!selector) return;
    for (const record of records) for (const node of record.addedNodes) {
      if (node instanceof Element && !['SCRIPT', 'STYLE', 'LINK'].includes(node.tagName)) queuedRoots.add(node);
    }
    if (queuedRoots.size && !flushTimer) flushTimer = setTimeout(flush, 0);
  });
  function watch() {
    if (!observing && pending.size && document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
      observing = true;
    }
  }
  rebuild();
  scan(document);
  watch();
  document.addEventListener('shopify:section:load', event => { scan(event.target); watch(); });
  window.addEventListener('online', () => { retryAfter.clear(); scan(document); watch(); });
  window.AyeiorModuleLoader = { version: '2.1', scan };
})();
